const chatAndTopBtns = document.querySelectorAll('.steel-lp-nav-container button');

chatAndTopBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        console.log(btn.name);
        if (btn.name === 'live-chat') { /*open live chat code here*/ };
        if (btn.name === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); };
    });
});

////////////////////////////////////
// OVERFLOW BORDER HELPER
////////////////////////////////////
function updateOverflowBorders(root = document) {
    const targets = root.querySelectorAll
    ? root.querySelectorAll('.overflow-border')
    : []; // root may be an element or document

    targets.forEach(el => {
      const isOverflowing = el.scrollWidth > el.clientWidth;
      el.classList.toggle('active', isOverflowing);
    });
}

// Optional: keep them updated if their size/content changes
function attachResizeObservers() {
    if (!('ResizeObserver' in window)) return;
    const ro = new ResizeObserver(entries => {
        for (const { target } of entries) {
            const isOverflowing = target.scrollWidth > target.clientWidth;
            target.classList.toggle('active', isOverflowing);
        }
    });
    document.querySelectorAll('.overflow-border').forEach(el => ro.observe(el));
}

////////////////////////////////////
// LAZY LOAD FOR OFF-SCREEN IMAGES
// + SECTION REVEAL ON SCROLL
////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
    const lazyImages   = document.querySelectorAll('img[data-src]');
    const lazySections = document.querySelectorAll('.lazy-section');
    const lazyIframes  = document.querySelectorAll('iframe[data-src]');

    // Initial check (in case some are already present)
    updateOverflowBorders();
    attachResizeObservers();

    const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const target = entry.target;

        // Handle images
        if (target.tagName === 'IMG' && target.dataset.src) {
            target.src = target.dataset.src;
            target.removeAttribute('data-src');
            target.onload = () => {
				target.classList.add('loaded');
				// After the image paints, re-check any overflow containers in the same section / DOM
				requestAnimationFrame(() => updateOverflowBorders(document));
            };
        }

        // Handle iframes (YouTube/Vimeo/etc)
        if (target.tagName === 'IFRAME' && target.dataset.src) {
            target.src = target.dataset.src;
            target.removeAttribute('data-src');
            target.addEventListener('load', () => {
				target.classList.add('loaded');
				requestAnimationFrame(() => updateOverflowBorders(document));
            });
        }

        // Handle sections
        if (target.classList.contains('lazy-section')) {
            target.classList.add('section-visible');
            // Wait a frame so layout settles, then check overflow inside this section only
            requestAnimationFrame(() => updateOverflowBorders(target));
        }

        obs.unobserve(target);
    });
    }, {
        root: null,
        rootMargin: '100px',
        threshold: 0.1
    });

  [...lazyImages, ...lazySections, ...lazyIframes].forEach(el => observer.observe(el));

  // Re-check on resize (throttled to rAF)
    let resizeScheduled = false;
    window.addEventListener('resize', () => {
        if (resizeScheduled) return;
        resizeScheduled = true;
        requestAnimationFrame(() => {
			resizeScheduled = false;
			updateOverflowBorders();
        });
    });

    // Also re-check once all blocking resources are done
    window.addEventListener('load', () => updateOverflowBorders());
});

// Feature section dropdowns
document.querySelectorAll('.tab-container').forEach(tab => {
    tab.addEventListener('click', () => {
        const wrapper = tab.closest('.dropdown-container');

        if (wrapper.classList.contains('is-animating')) return;

        const corespondingTab = wrapper.querySelector(`.tab-container[data-tab-id="${tab.dataset.tabId}"]`);
        const corespondingContent = wrapper.querySelector(`.content-container[data-tab-id="${tab.dataset.tabId}"]`);

        if (corespondingContent.classList.contains('active')) return;

        wrapper.querySelectorAll('.content-container').forEach(cc => { cc.classList.remove('active'); });

        setTimeout(() => {
            corespondingContent.classList.add('active');
        }, 400);
    });
});

const applicationContainer = document.querySelector('.blade-type');
const bladeSizeContainer = document.querySelector('.blade-size');
const hiddenSearchFilterInput = document.querySelector('.blades-lp-hidden-search-filter');
const productFilters = document.querySelectorAll('.product-type .item');
const applicationFilters = document.querySelectorAll('.blade-type .item');
const sizeFilters = document.querySelectorAll('.blade-size .item');
const collectionItems = document.querySelectorAll('.blade-collection-item');

const carouselContainers = document.querySelectorAll('.carousel-container');
const imageContainers = document.querySelectorAll('.image-container');
const infoContainers = document.querySelectorAll('.info-slide');
const slideIndicators = document.querySelectorAll('.slide-indicator');


let selectedProduct = ''
let selectedApplication = ''
let selectedSize = ''
let filteredString = ''
let activeSlideNumber = 1;

//filters the collection results
function updateInputValue(selectedProduct, selectedApplication, selectedSize) {
    const parts = [];

    if (selectedProduct) parts.push(selectedProduct);
    if (selectedApplication) parts.push(selectedApplication);
    if (selectedSize) parts.push(selectedSize);

    const filterString = parts.join(',');

    collectionItems.forEach(item => {
        let matches = true;

        if (selectedProduct) {
            matches = matches && item.dataset.compatibleWith === selectedProduct;
        }

        if (selectedApplication) {
            matches = matches && item.dataset.bladeType === selectedApplication;
        }

        if (selectedSize) {
            matches = matches && item.dataset.bladeSize === selectedSize;
        }

        if (matches) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
                
        if (filterString.length === 0) {
            item.classList.remove('active');
        }
    });

    return filterString;
}

//handles filer class list toggling
productFilters.forEach(productType => {
    productType.addEventListener('click', () => {

        applicationContainer.style.display = 'block';
        bladeSizeContainer.style.display = 'block';

        productFilters.forEach(filter => { 
            filter.classList.remove('active'); 
        });

        applicationFilters.forEach(filter => {
            filter.classList.remove('show');
            if (filter.dataset.compProds.includes(productType.dataset.type)) {
                filter.classList.add('show');
            }
        });

        const bladeSizes = productType.dataset.bladeSizes
            .split(',')
            .map(size => size.trim());

        sizeFilters.forEach(filter => {
            const size = filter.dataset.size;

            if (bladeSizes.includes(size)) {
                filter.classList.add('show');
            } else {
                filter.classList.remove('show');
            }
        });

        if (productType.dataset.type == selectedProduct) {
            selectedProduct = '';
            applicationFilters.forEach(filter => { filter.classList.remove('show'); });
            sizeFilters.forEach(filter => { filter.classList.remove('show'); });
        } else {
            selectedProduct = productType.dataset.type;
            productType.classList.add('active');
        }

        updateInputValue(selectedProduct, selectedApplication, selectedSize);
    });
});

applicationFilters.forEach(application => {
    application.addEventListener('click', () => {
        applicationFilters.forEach(filter => {
            filter.classList.remove('active');
        });

        if (application.dataset.bladeType == selectedApplication) {
            selectedApplication = '';
        } else {
            selectedApplication = application.dataset.bladeType;
            application.classList.add('active');
        }
        updateInputValue(selectedProduct, selectedApplication, selectedSize);
        
        carouselContainers.forEach(container => {
            container.classList.remove('active');
            if (container.dataset.application == selectedApplication) {
                container.classList.add('active');
            }
        });
    });
});

sizeFilters.forEach(bladeSize => {
    bladeSize.addEventListener('click', () => {
        sizeFilters.forEach(filter => {
            filter.classList.remove('active');
        });

        if (bladeSize.dataset.size == selectedSize) {
            bladeSize.classList.remove('active');
            selectedSize = '';
        } else {
            selectedSize = bladeSize.dataset.size;
            bladeSize.classList.add('active');
        }
        updateInputValue(selectedProduct, selectedApplication, selectedSize);
    });
});

//BLADE COLLECTION FEATURE CAROUSEL BUTTON HANDLER
document.querySelectorAll('.carousel-container .direction-btn').forEach(btn => {
    btn.addEventListener('click', () => {

        //Increment the value based on button value.
        activeSlideNumber += parseInt(btn.value);

        //If the value goes above 5 or below 1 loop
        if (activeSlideNumber > 5) { 
            activeSlideNumber = 1; 
        } else if (activeSlideNumber < 1) { 
            activeSlideNumber = 5; 
        }
            
        //Remove the active class from each image.
        imageContainers.forEach(e => {
            e.classList.remove('active');
            if (parseInt(e.dataset.slide) === parseInt(activeSlideNumber)) {                  
                e.classList.add('active');
            }
        });

        //Remove the active class from each info.
        infoContainers.forEach(e => {
            e.classList.remove('active');
            if (parseInt(e.dataset.slide) === parseInt(activeSlideNumber)) {
                e.classList.add('active');
            }
        });

        //Remove the active class from each info.
        slideIndicators.forEach(e => {
            e.classList.remove('active');
            if (parseInt(e.dataset.slide) === parseInt(activeSlideNumber)) {
                e.classList.add('active');
            }
        });
    });
});

document.getElementById('discover-btn')?.addEventListener('click', () => {
  document.querySelector('.lp-video-player-anchor')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});